import { useEffect, useState } from 'react';
import _get from 'lodash/get';

// export const isAtBottom = ({ containerEl, contentEl }) => {
//     const containerOffsetHeight = _get(containerEl, 'offsetHeight', 0);
//     const contentOffsetHeight = _get(contentEl, 'offsetHeight', 0);
//     const containerScrollTop = _get(containerEl, 'scrollTop', 0);
//     return contentOffsetHeight - containerOffsetHeight === containerScrollTop;
// };

export const isAtBottomByContentDimensions = ({ containerEl, contentDimensions }) => {
    const containerOffsetHeight = _get(containerEl, 'offsetHeight', 0);
    const containerScrollTop = _get(containerEl, 'scrollTop', 0);
    const contentOffsetHeight = _get(contentDimensions, 'height', 0);
    return contentOffsetHeight - containerOffsetHeight === containerScrollTop;
};

// Hook that returns the window width and height
export const useWindowSize = () => {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
    });

    useEffect(() => {
        // Handler to call on window resize
        const handleResize = () => {
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        // Add event listener
        window.addEventListener('resize', handleResize);

        // Call handler right away so state gets updated with initial window size
        handleResize();

        // Remove event listener on cleanup
        return () => window.removeEventListener('resize', handleResize);
    }, []); // Empty array ensures that effect is only run on mount

    return windowSize;
};

export const useElementDimensions = element => {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [elDimensions, setElDimensions] = useState({
        width: undefined,
        height: undefined,
    });

    useEffect(() => {
        // Handler to call on window resize
        const handleResize = () => {
            if (element) {
                const dimensions = element.getBoundingClientRect();
                // Set element dimension to state
                setElDimensions(dimensions);
            }
        };

        // Add event listener
        window.addEventListener('resize', handleResize);

        // Call handler right away so state gets updated with initial window size
        handleResize();

        // Remove event listener on cleanup
        return () => window.removeEventListener('resize', handleResize);
    }, [element]); // Empty array ensures that effect is only run on mount

    return elDimensions;
};
